import { render, staticRenderFns } from "./baseInfoAdd.vue?vue&type=template&id=522ee070"
import script from "./baseInfoAdd.vue?vue&type=script&lang=js"
export * from "./baseInfoAdd.vue?vue&type=script&lang=js"
import style0 from "./baseInfoAdd.vue?vue&type=style&index=0&id=522ee070&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports